import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import {
  TextField,
  Switch,
  FormControlLabel,
  Checkbox,
  FormGroup,
  FormControl,
  Select,
  MenuItem,
  Typography,
  Box
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import './demo-form.scss';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(2)
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    paddingTop: theme.spacing(3)
  },
  nameInput: {
    maxWidth: 800
  },
  numberInput: {
    maxWidth: 80
  },
  select: {
    minWidth: 120,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  inline: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  inlineTypography: {
    display: 'inline',
    marginRight: theme.spacing(1)
  }
}));

const DemoForm = () => {
  const { data } = useSelector(state => state.dataDetail);
  const classes = useStyles();
  const [formData, setFormData] = useState({
    name: '',
    renewalEnabled: true,
    allowRenewal: 30,
    renewalPeriod: 'Day(s)',
    renewalReminder: true,
    sendReminder: 30,
    reminderPeriod: 'Day(s)',
    locationEnabled: true,
    allowMultipleLocations: true,
    locationTypes: {
      point: true,
      segment: true,
      polygon: true
    }
  });

  useEffect(() => {
    setFormData({ ...formData, name: data?.name });
  }, [data?.name]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleInputChange = event => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleSwitchChange = event => {
    setFormData({ ...formData, [event.target.name]: event.target.checked });
  };

  const handleSelectChange = event => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleCheckboxChange = event => {
    setFormData({
      ...formData,
      locationTypes: {
        ...formData.locationTypes,
        [event.target.name]: event.target.checked
      }
    });
  };

  const periodOptions = ['Day(s)', 'Week(s)', 'Month(s)', 'Year(s)'];

  return (
    <div styleName="demo-form">
      <Box className={classes.root}>
        {/* Name Section */}
        <Box className={classes.section}>
          <Typography variant="subtitle2">Name</Typography>
          <TextField
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            variant="outlined"
            className={classes.nameInput}
          />
        </Box>

        {/* Renewal Section */}
        <Box className={classes.section}>
          <Typography variant="subtitle1">Renewal</Typography>
          <FormControlLabel
            control={
              <Switch
                checked={formData.renewalEnabled}
                onChange={handleSwitchChange}
                name="renewalEnabled"
                color="primary"
              />
            }
            label="Enabled"
          />
          <Box className={classes.inline}>
            <Typography className={classes.inlineTypography}>
              Allow renewal
            </Typography>
            <TextField
              name="allowRenewal"
              type="number"
              value={formData.allowRenewal}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              className={classes.numberInput}
            />
            <FormControl variant="outlined" size="small">
              <Select
                name="renewalPeriod"
                value={formData.renewalPeriod}
                onChange={handleSelectChange}
                className={classes.select}
              >
                {periodOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography>before record expires.</Typography>
          </Box>
          <FormControlLabel
            control={
              <Switch
                checked={formData.renewalReminder}
                onChange={handleSwitchChange}
                name="renewalReminder"
                color="primary"
              />
            }
            label="Renewal reminder"
          />
          <Box className={classes.inline}>
            <Typography className={classes.inlineTypography}>
              Send renewal reminder
            </Typography>
            <TextField
              name="sendReminder"
              type="number"
              value={formData.sendReminder}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              className={classes.numberInput}
            />
            <FormControl variant="outlined" size="small">
              <Select
                name="reminderPeriod"
                value={formData.reminderPeriod}
                onChange={handleSelectChange}
                className={classes.select}
              >
                {periodOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography>before record expires.</Typography>
          </Box>
        </Box>

        {/* Location Section */}
        <Box className={classes.section}>
          <Typography variant="subtitle1">Location</Typography>
          <FormControlLabel
            control={
              <Switch
                checked={formData.locationEnabled}
                onChange={handleSwitchChange}
                name="locationEnabled"
                color="primary"
              />
            }
            label="Enabled"
          />
          <FormControlLabel
            control={
              <Switch
                checked={formData.allowMultipleLocations}
                onChange={handleSwitchChange}
                name="allowMultipleLocations"
                color="primary"
              />
            }
            label="Allow multiple locations"
          />
          <Box className={classes.inline}>
            <Typography className={classes.inlineTypography}>
              Location types allowed:
            </Typography>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.locationTypes.point}
                    onChange={handleCheckboxChange}
                    name="point"
                    color="primary"
                  />
                }
                label="Point"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.locationTypes.segment}
                    onChange={handleCheckboxChange}
                    name="segment"
                    color="primary"
                  />
                }
                label="Segment"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.locationTypes.polygon}
                    onChange={handleCheckboxChange}
                    name="polygon"
                    color="primary"
                  />
                }
                label="Polygon"
              />
            </FormGroup>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default DemoForm;
